/**
 * Resolve link values for CTA buttons that may point to internal pages or external URLs.
 */
import { resolvePageUrl } from './pageUtils';

/**
 * Resolve a button link value to an href.
 * @param {string|null|undefined} buttonLink — raw link value from block content
 * @param {string} username
 * @param {boolean} isOnOwnDomain
 * @returns {string}
 */
export const resolveLink = (buttonLink, username, isOnOwnDomain) => {
  if (!buttonLink) return '#';

  // Internal page link: "page:{slug}" or "page:/" for home
  if (buttonLink.startsWith('page:')) {
    const slug = buttonLink.slice(5); // strip "page:" prefix
    return resolvePageUrl(slug === '/' ? null : slug, username, isOnOwnDomain);
  }

  // Already a full URL
  if (buttonLink.startsWith('http://') || buttonLink.startsWith('https://')) {
    return buttonLink;
  }

  // Relative path or special protocol (mailto:, tel:, etc.) — pass through as-is
  if (buttonLink.startsWith('/') || buttonLink.startsWith('mailto:') || buttonLink.startsWith('tel:')) {
    return buttonLink;
  }

  // Bare URL — prepend https
  return `https://${buttonLink}`;
};

/**
 * Check if a resolved link is an internal path (starts with /).
 * Useful for deciding between <Link> (SPA) and <a> (external).
 * @param {string} href
 * @returns {boolean}
 */
export const isInternalLink = (href) => {
  return href.startsWith('/') || href === '#';
};
